import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2952c718"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "firms" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "brush-map__title" }, "2. Выберите фирму ёршика", -1))
const _hoisted_3 = { class: "firms__buttons" }

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  brushesFirm: Object,
},
  emits: ['changeFirm', 'resetColors'],
  setup(__props, { emit }) {

const props = __props





const firm = computed(() => props.brushesFirm.nameFirm)

const changeFirm = function (
  nameFirm: string,
  firstGroup: string,
  secondGroup = 'none'
) {
  emit('changeFirm', { nameFirm, firstGroup, secondGroup })
  emit('resetColors')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "firms__button--curaprox",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (changeFirm('Curaprox', 'PRIME', 'PERIO')))
      }, " Curaprox "),
      _createElementVNode("button", {
        class: _normalizeClass([{
          firms__button_background: _unref(firm) === 'TePe',
        }, "firms__button"]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (changeFirm('TePe', 'ЖЕСТКОСТЬ')))
      }, " TePe ", 2),
      _createElementVNode("button", {
        class: _normalizeClass([{
          firms__button_background: _unref(firm) === 'Interprox',
        }, "firms__button"]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (changeFirm('Interprox', 'PLUS')))
      }, " Interprox ", 2),
      _createElementVNode("button", {
        class: _normalizeClass([{
          firms__button_background: _unref(firm) === 'Curasept',
        }, "firms__button"]),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (changeFirm('Curasept', 'TREATMENT', 'PREVENTION')))
      }, " Curasept ", 2),
      _createElementVNode("button", {
        class: _normalizeClass([{
          firms__button_background: _unref(firm) === 'Pesitro',
        }, "firms__button"]),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (changeFirm('Pesitro', 'none')))
      }, " Pesitro ", 2)
    ])
  ]))
}
}

})